import { render } from "./ClientContractExpired.vue?vue&type=template&id=3fd96a68&scoped=true"
import script from "./ClientContractExpired.vue?vue&type=script&lang=js"
export * from "./ClientContractExpired.vue?vue&type=script&lang=js"

import "./ClientContractExpired.vue?vue&type=style&index=0&id=3fd96a68&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd96a68"]])

export default __exports__